<header
  class="relative flex min-h-[640px] w-full items-center justify-center overflow-hidden bg-shl-navy pt-10 pb-20"
>
  <div class="absolute inset-0 z-0">
    <img
      [attr.alt]="'hero.image_alt' | translate"
      title="{{ 'hero.image_alt' | translate }}"
      class="h-full w-full object-cover opacity-30 mix-blend-overlay"
      src="https://lh3.googleusercontent.com/aida-public/AB6AXuAae2apY66BjF5p8v0x-D8uV4af2QO3Ftjxos8aRsrxFTWhsJj1ZS36oSmn0Jh13p3dUYQJ-5HGN78WxA3CcbLnIrk5WMKzNocKHdae2xSMIF0hEJjxTF-IwyMJ_aVfm360pr0o8YWd_jFOvLek1jWHh4Xkzj0rb1com7Vn2smZZNY0dJE08xy5zzWgnX9sp5dvuKbQIz7FCJ5untXh7PFaeD7-EEA9THpkBZQ-n82D6CztFqZ-gwY7AeKf51kuN0x3IgBbfZovZvJq"
    />
    <div class="absolute inset-0 bg-gradient-to-r from-shl-navy via-shl-navy/80 to-transparent"></div>
  </div>
  <div class="relative z-10 mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 lg:grid-cols-2 lg:px-8">
    <div class="flex flex-col justify-center space-y-8">
      <div
        class="inline-flex w-fit items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 backdrop-blur-sm shadow-lg"
      >
        <span class="h-2 w-2 rounded-full bg-green-400 animate-pulse"></span>
        <span class="text-xs font-bold text-white tracking-wide uppercase">
          {{ 'hero.badge' | translate }}
        </span>
      </div>
      <h1 class="text-5xl font-black leading-[1.1] tracking-tight text-white sm:text-6xl drop-shadow-lg">
        {{ 'hero.title_lead' | translate }} <br />
        <span class="text-transparent bg-clip-text bg-gradient-to-r from-sky-300 to-sky-500">
          {{ 'hero.title_highlight' | translate }}
        </span>
        {{ 'hero.title_trail' | translate }}
      </h1>
      <p class="max-w-lg text-lg text-blue-100 leading-relaxed font-light">
        {{ 'hero.description' | translate }}
      </p>
      <div class="flex flex-wrap gap-4 pt-2">
        <button
          class="flex h-12 items-center gap-2 rounded-lg rounded-tr-[20px] bg-shl-sky px-6 text-sm font-bold text-white transition-all hover:bg-sky-400 shadow-lg shadow-shl-sky/20"
          type="button"
        >
          {{ 'hero.cta_explore_network' | translate }}
          <mat-icon fontSet="material-symbols-outlined" class="text-lg">arrow_forward</mat-icon>
        </button>
        <button
          class="flex h-12 items-center gap-2 rounded-lg rounded-tr-[20px] border border-white/30 px-6 text-sm font-bold text-white backdrop-blur-sm transition-colors hover:bg-white/10"
          type="button"
        >
          <mat-icon fontSet="material-symbols-outlined">play_circle</mat-icon>
          {{ 'hero.cta_how_it_works' | translate }}
        </button>
      </div>
    </div>
    <div class="flex items-center justify-center lg:justify-end">
      <div class="glass-card w-full max-w-md rounded-2xl rounded-tr-[40px] p-8 shadow-2xl shadow-black/30">
        <div class="mb-6 flex items-center justify-between">
          <h3 class="text-xl font-bold text-shl-navy">{{ 'hero.quick_rate.title' | translate }}</h3>
          <div class="rounded-full bg-blue-50 p-2 text-shl-sky shadow-sm">
            <mat-icon fontSet="material-symbols-outlined">calculate</mat-icon>
          </div>
        </div>
        <form class="space-y-4">
          <div class="space-y-1">
            <label class="text-xs font-bold uppercase text-gray-500" for="quick-rate-origin">
              {{ 'hero.quick_rate.origin_label' | translate }}
            </label>
            <div class="relative">
              <mat-icon
                fontSet="material-symbols-outlined"
                class="absolute left-3 top-3 text-gray-400"
              >
                flight_takeoff
              </mat-icon>
              <select
                class="w-full appearance-none rounded-lg border border-gray-200 bg-white py-3 ps-10 pe-4 text-sm font-medium text-shl-navy focus:border-shl-sky focus:ring-shl-sky shadow-sm"
                id="quick-rate-origin"
                name="origin"
                [(ngModel)]="originValue"
              >
                <option [value]="'hero.quick_rate.origin_options.rades_tunisia'">
                  {{ 'hero.quick_rate.origin_options.rades_tunisia' | translate }}
                </option>
                <option [value]="'hero.quick_rate.origin_options.tunis_carthage'">
                  {{ 'hero.quick_rate.origin_options.tunis_carthage' | translate }}
                </option>
                <option [value]="'hero.quick_rate.origin_options.sfax'">
                  {{ 'hero.quick_rate.origin_options.sfax' | translate }}
                </option>
              </select>
            </div>
          </div>
          <div class="space-y-1">
            <label class="text-xs font-bold uppercase text-gray-500" for="quick-rate-destination">
              {{ 'hero.quick_rate.destination_label' | translate }}
            </label>
            <div class="relative">
              <mat-icon fontSet="material-symbols-outlined" class="absolute left-3 top-3 text-gray-400">
                flight_land
              </mat-icon>
              <select
                class="w-full appearance-none rounded-lg border border-gray-200 bg-white py-3 ps-10 pe-4 text-sm font-medium text-shl-navy focus:border-shl-sky focus:ring-shl-sky shadow-sm"
                id="quick-rate-destination"
                name="destination"
                [(ngModel)]="destinationValue"
              >
                <option [value]="'hero.quick_rate.destination_options.global_hub_europe'">
                  {{ 'hero.quick_rate.destination_options.global_hub_europe' | translate }}
                </option>
                <option [value]="'hero.quick_rate.destination_options.global_hub_asia'">
                  {{ 'hero.quick_rate.destination_options.global_hub_asia' | translate }}
                </option>
                <option [value]="'hero.quick_rate.destination_options.global_hub_americas'">
                  {{ 'hero.quick_rate.destination_options.global_hub_americas' | translate }}
                </option>
              </select>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <div class="space-y-1">
              <label class="text-xs font-bold uppercase text-gray-500" for="quick-rate-weight">
                {{ 'hero.quick_rate.weight_label' | translate }}
              </label>
              <input
                class="w-full rounded-lg border border-gray-200 bg-white p-3 text-sm font-medium focus:border-shl-sky focus:ring-shl-sky shadow-sm"
                id="quick-rate-weight"
                name="weight"
                [placeholder]="'hero.quick_rate.weight_placeholder' | translate"
                type="number"
                [(ngModel)]="weightValue"
              />
            </div>
            <div class="space-y-1">
              <label class="text-xs font-bold uppercase text-gray-500" for="quick-rate-load-type">
                {{ 'hero.quick_rate.load_type_label' | translate }}
              </label>
              <select
                class="w-full appearance-none rounded-lg border border-gray-200 bg-white p-3 text-sm font-medium focus:border-shl-sky focus:ring-shl-sky shadow-sm"
                id="quick-rate-load-type"
                name="loadType"
                [(ngModel)]="loadTypeValue"
              >
                <option [value]="'hero.quick_rate.load_type_general'">
                  {{ 'hero.quick_rate.load_type_general' | translate }}
                </option>
                <option [value]="'hero.quick_rate.load_type_perishable'">
                  {{ 'hero.quick_rate.load_type_perishable' | translate }}
                </option>
              </select>
            </div>
          </div>
          <button
            class="btn-gradient mt-2 flex w-full items-center justify-center gap-2 rounded-lg rounded-tr-[20px] py-3.5 text-sm font-bold text-white shadow-lg transition-transform hover:translate-y-[-2px] hover:shadow-xl"
            type="button"
            (click)="onGetBestRate()"
          >
            {{ 'hero.quick_rate.submit' | translate }}
            <mat-icon fontSet="material-symbols-outlined" class="text-lg">arrow_forward</mat-icon>
          </button>
        </form>
      </div>
    </div>
  </div>
</header>
